module.exports = __webpack_public_path__ + "static/media/banner.db535175.jpg";